"use client";

import * as React from "react";
import { MoonIcon, SunIcon, SwitchIcon } from "@radix-ui/react-icons";
import { useTheme } from "next-themes";

import { useLocalStorage } from "react-use";

export function ModeToggle() {
  const { theme, setTheme } = useTheme();
  const [localStorageUserTheme, setLocalStorageUserTheme] = useLocalStorage(
    "user-theme",
    "system",
  );

  return (
    <div className="flex flex-row items-center px-2 opacity-50 cursor-pointer hover:pl-4  group hover:bg-transparent hover:opacity-80 transition-opacity duration-200">
      <div className="flex flex-row w-0 text-sm font-normal opacity-0 group-hover:w-12 group-hover:opacity-100 transition-all  gap-4">
        {theme != "system" && (
          <SwitchIcon
            onClick={() => {
              setLocalStorageUserTheme("system");
              setTheme("system");
            }}
            className="w-4 h-4 "
          />
        )}
        {theme != "light" && (
          <SunIcon
            onClick={() => {
              setLocalStorageUserTheme("light");
              setTheme("light");
            }}
            className="w-4 h-4"
          />
        )}
        {theme != "dark" && (
          <MoonIcon
            onClick={() => {
              setLocalStorageUserTheme("dark");
              setTheme("dark");
            }}
            className="w-4 h-4 "
          />
        )}
      </div>
      <div >
        {theme == "light" && <SunIcon className="w-4 h-4 overflow-hidden opacity-100  group-hover:opacity-0 group-hover:w-0 transition-all" />}
        {theme == "dark" && <MoonIcon className="w-4 h-4 overflow-hidden opacity-100 group-hover:opacity-0 group-hover:w-0 transition-all" />}
        {theme == "system" && <SwitchIcon className="w-4 h-4 overflow-hidden opacity-100 group-hover:opacity-0 group-hover:w-0 transition-all" />}
      </div>
    </div>
  );
}
